import {IBizAtmosphere, IBusiness} from "@/views/editor/service/business";
import {AEditor} from "@/views/editor/service/editor";
import {IActivityBusinessMeta} from "@/model/activity";
import {AAtmosphere} from "@/views/editor/service/atmosphere/layer";
import {CheckboxOptionType} from "ant-design-vue/es/checkbox/interface";
import {IRule} from "@/views/editor/service/types";


export interface IAtmosphereMeta {
    music_url: string
    virtual: {
        view: number
        sign: number
        share: number
    }
    show_barrage: boolean
    show_statistics: boolean
    is_show_pay_history: boolean
    share_card_title: string
    is_append_employee_name_in_share_card_title: boolean
    share_card_title_employee_name: string
    is_use_main_image_to_auth: boolean
}

export default class Atmosphere extends AAtmosphere implements IBizAtmosphere {

    subs: CheckboxOptionType[] = [];
    readonly opt: IAtmosphereMeta

    constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
        this.opt = this.meta.setting as IAtmosphereMeta
    }

    resetMeta(): IBusiness {
        const opt: IAtmosphereMeta = {
            is_append_employee_name_in_share_card_title: false,
            is_show_pay_history: false,
            music_url: "",
            share_card_title: "",
            share_card_title_employee_name: "",
            show_barrage: false,
            show_statistics: false,
            virtual: {share: 0, sign: 0, view: 0},
            is_use_main_image_to_auth: false,
        }
        Object.assign(this.opt, opt)
        return this;
    }

    setRules(origin: string, rules: IRule[]): void {
        /*
        if (this.opt.inputs.some(x => x.owner === owner)) {
            const l = this.opt.inputs.filter(x => x.owner !== owner);
            if (inputs.length > 0) l.push(...inputs)
            this.opt.inputs = l
        } else if (inputs.length > 0) this.opt.inputs.push(...inputs)
         */
    }

    initVirtual() {
        this.opt.virtual.sign = Math.round(Math.random() * 101 + 100)
        this.opt.virtual.view = Math.round(this.opt.virtual.sign * 12.32)
        this.opt.virtual.share = Math.round(this.opt.virtual.sign * 2.56)
    }

    clearVirtual() {
        this.opt.virtual.sign = 0
        this.opt.virtual.view = 0
        this.opt.virtual.share = 0
    }
}